import type { TopUpPack, TopUpReceipt } from '@nine/shared';

export type PayMethod = 'promptpay' | 'card' | 'truemoney';

export const PAY_METHODS: readonly [PayMethod, string][] = [
  ['promptpay', 'พร้อมเพย์ (QR)'],
  ['card', 'บัตรเครดิต/เดบิต'],
  ['truemoney', 'ทรูมันนี่ วอลเล็ท'],
];

/** Takes the money for a pack and returns the receipt to credit. */
export interface PaymentGateway {
  /** True while no real money moves (the offline prototype). */
  readonly sandbox: boolean;
  pay(pack: TopUpPack, method: PayMethod): Promise<TopUpReceipt>;
}

/**
 * Stand-in until the server exists (phase 2): waits a moment and approves every payment. The real
 * gateway will create a charge on the server, and the provider's webhook will credit the jade there.
 */
export const sandboxGateway: PaymentGateway = {
  sandbox: true,
  pay: (pack, method) =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            id: `sbx-${method}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
            pack: pack.id,
            baht: pack.baht,
          }),
        900,
      ),
    ),
};
